export default "__VITE_ASSET__6efa1cae__"